import { TypographyH1 } from "@/components/ui/typography"
import { useAutoTranslation } from "@/entities"
import { ChangeLang } from "@/features"
import { DISCOVERED_TRANSLATION_KEYS, LANG_KEYS } from "@/shared/constants"

export const LanguagePage = () => {
  const { t } = useAutoTranslation()

  return (
    <div className="h-full p-4">
      <TypographyH1 className="mb-2 text-left text-2xl">
        {t(LANG_KEYS.LANGUAGE)}
      </TypographyH1>
      <p className="text-muted-foreground mb-6 text-sm">
        {t(DISCOVERED_TRANSLATION_KEYS.INTERFACE_LANGUAGE_DESCRIPTION)}
      </p>

      <section className="max-w-lg rounded-xl border p-4">
        <h2 className="mb-1 font-semibold">
          {t(DISCOVERED_TRANSLATION_KEYS.INTERFACE_LANGUAGE)}
        </h2>
        <p className="text-muted-foreground mb-4 text-sm">
          {t(DISCOVERED_TRANSLATION_KEYS.INTERFACE_LANGUAGE_HELP)}
        </p>
        <ChangeLang />
      </section>
    </div>
  )
}
